import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

document.addEventListener('DOMContentLoaded', function () {
	const calendarEl = document.getElementById('jobCalendar');

	if (!calendarEl) {
		return;
	}

	// Add loading indicator
	const loadingEl = document.createElement('div');
	loadingEl.className = 'calendar-loading';
	loadingEl.innerHTML = '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading events...</span></div><p class="mt-2">Loading calendar events...</p>';
	loadingEl.style.cssText = 'text-align: center; padding: 40px; font-size: 14px; color: #6c757d;';
	calendarEl.appendChild(loadingEl);

	let eventCounter = 0; // Initialize a counter for the events

	// Create the calendar instance and store it in a variable we can reference later.
	const calendar = new Calendar(calendarEl, {
		plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
		initialView: 'dayGridMonth',
		headerToolbar: {
			left: 'prev,next today',
			center: 'title',
			right: 'dayGridMonth,dayGridWeek,dayGridDay',
		},
		firstDay: 1, // Start the week on Monday
		events: '/api/jobs/events/', // API endpoint to fetch job data
		eventDataTransform: function (eventData) {
			// Check if the event has an 'end' and if it's an all-day event
			if (eventData.end) {
				let endDate = new Date(eventData.end);
				endDate.setDate(endDate.getDate() + 1);
				eventData.end = endDate.toISOString().split('T')[0];
			}

			// Add CSS class based on job_type
			if (eventData.job_type) {
				// Convert job_type to a CSS-friendly class name (lowercase, replace spaces with hyphens)
				const jobTypeClass = 'job-type-' + eventData.job_type.toLowerCase().replace(/\s+/g, '-');
				eventData.className = jobTypeClass;
			} else {
				// Fallback class if no job_type (no staff assigned yet)
				eventData.className = 'job-type-unassigned';
			}

			return eventData;
		},
		// Use eventContent to customize how events are rendered.
		eventContent: function (arg) {
			eventCounter++; // Increment the counter for each event

			// Create a container div for the event content
			let containerEl = document.createElement('div');

			// Create an element for the event title
			let titleEl = document.createElement('span');
			titleEl.innerText = arg.event.title;
			titleEl.classList.add('event-title');

			// Create a button that will open the modal
			let buttonEl = document.createElement('button');
			buttonEl.innerHTML = 'View Staff';
			buttonEl.type = 'button';
			buttonEl.dataset.bsToggle = 'modal';
			buttonEl.dataset.bsTarget = '#viewStaffModal';
			// Store the job id on the button so we know which event's staff to load.
			buttonEl.dataset.jobId = arg.event.id;
			buttonEl.classList.add('event-alert-btn');

			// Prevent eventClick from firing when clicking the button.
			buttonEl.addEventListener('click', function (e) {
				e.stopPropagation();
			});

			// Append both the title and button to the container.
			containerEl.appendChild(titleEl);
			containerEl.appendChild(buttonEl);

			// Return the container as the event content.
			return {domNodes: [containerEl]};
		},
		// Default eventClick: this will trigger when clicking outside the button.
		eventClick: function (info) {
			window.location.href = '/jobs/' + info.event.id + '/';
		},
		// Remove loading indicator when events are loaded
		loading: function (isLoading) {
			if (!isLoading && loadingEl.parentNode) {
				loadingEl.remove();
			}
		},
		// Handle event loading errors
		eventSourceFailure: function (error) {
			if (loadingEl.parentNode) {
				loadingEl.innerHTML = '<div class="alert alert-warning" role="alert">Failed to load calendar events. Please refresh the page.</div>';
			}
			console.error('Failed to load events:', error);
		}
	});

	calendar.render();

	// Modal handling:
	const viewStaffModalEl = document.getElementById('viewStaffModal');
	const modalBodyEl = viewStaffModalEl.querySelector('.modal__body');

	// When the modal is shown, retrieve staff details from the event's extendedProps.
	viewStaffModalEl.addEventListener('shown.bs.modal', function (e) {
		// e.relatedTarget is the button that triggered the modal
		const button = e.relatedTarget;
		const jobId = button.dataset.jobId;

		// Clear any existing modal content
		clearModalContent();

		// Retrieve the corresponding event from the calendar.
		const jobEvent = calendar.getEventById(jobId);
		if (jobEvent && jobEvent.extendedProps.staff) {
			// Use the staff data already present on the event.
			const staffData = jobEvent.extendedProps.staff;
			renderStaffTables(staffData);
		} else {
			console.error('No staff data found for job id', jobId);
		}
	});

	// When the modal is hidden, clear the content.
	viewStaffModalEl.addEventListener('hidden.bs.modal', function () {
		clearModalContent();
	});

	// Render a table for each staff role if there are staff for that role.
	function renderStaffTables(data) {
		data.forEach(group => {
			if (group.staff && group.staff.length > 0) {
				// Create a heading for the role.
				const roleHeading = document.createElement('h6');
				roleHeading.classList.add('mb-2');
				roleHeading.textContent = group.role;
				modalBodyEl.appendChild(roleHeading);

				// Create a table for this role.
				const table = document.createElement('table');
				table.classList.add('table', 'table-striped');

				// Create table header.
				const thead = document.createElement('thead');
				thead.innerHTML = `<tr><th>Staff</th><th>Viewed</th></tr>`;
				table.appendChild(thead);

				// Create table body.
				const tbody = document.createElement('tbody');
				group.staff.forEach(staffObj => {
					const tr = document.createElement('tr');

					const tdStaff = document.createElement('td');
					tdStaff.textContent = staffObj.staff;
					tr.appendChild(tdStaff);

					const tdViewed = document.createElement('td');
					tdViewed.textContent = staffObj.has_been_viewed ? 'Yes' : 'No';
					tr.appendChild(tdViewed);

					tbody.appendChild(tr);
				});
				table.appendChild(tbody);

				// Append the table to the modal body.
				modalBodyEl.appendChild(table);
			}
		});
	}

	// Helper function to clear the modal content.
	function clearModalContent() {
		// Reset the modal body to its original heading.
		modalBodyEl.innerHTML = '<h3 class="modal__title text-center mb-0">Staff</h3>';
	}
});
